import { Component, Inject, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BarcodeScannerService } from 'src/app/services/hardware-service/barcode-scanner/barcode-scanner.service';

@Component({
  selector: 'app-barcode-scanner-modal',
  templateUrl: './barcode-scanner-modal.component.html',
  styleUrls: ['./barcode-scanner-modal.component.scss'],
})
export class BarcodeScannerModalComponent implements OnInit {
  private content: any;
  constructor(
    private modalCtrl: ModalController,
    private barcodeScannerService: BarcodeScannerService
  ) {
    this.content = undefined;
  }

  ngOnInit(): void {
    this.barcodeScannerService
      .openBarcodeScanner()
      .then((data) => {
        console.log(data)
        // if (data?.hasContent) {
        //   this.content = data.content;
        // }
        this.close();
      })
      .catch((e) => {
        console.log('error: ', e);
      });
  }

  close() {
    // this.barcodeScannerService.stopBarcodeScan();
    // return this.modalCtrl.dismiss(this.content);
  }
}
